<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="modalTitle"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Grid:"
      >
        <b-form-select
          v-model.trim="$v.selectedGrid.$model"
          :class="{ 'is-invalid': $v.selectedGrid.$error }"
          :disabled="inProgress"
          :options="grids"
        />
        <b-form-invalid-feedback
          v-if="!$v.selectedGrid.required"
        >
           Grid is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Row:"
      >
        <b-form-input
          v-model.trim="$v.selectedRow.$model"
          :class="{ 'is-invalid': $v.selectedRow.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.selectedRow.required"
        >
          Row is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      modalTitle: 'Add Table "Edit Row" component',
      inProgress: false,
      grids: [],
      selectedGrid: null,
      selectedRow: null,
      gsOptions: {}
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'dataGrid_options'
    ])
  },
  methods: {
    openModal () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    closeModal () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      const key = await db.dataGrid.widget.createEditRowComponent(this.selectedGrid, this.selectedRow, this.currentTab, this.gsOptions, this.currentSubTab);
      this.$store.commit('addedWidgetKey', key);

      this.gsOptions = {};

      this.inProgress = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.closeModal()
    }
  },
  validations: {
    selectedGrid: {
      required
    },
    selectedRow: {
      required
    }
  },
  created () {
    eventBus.$on('showAddDataGridEditRowFormModal', ({ gsOptions }) => {
      this.gsOptions = gsOptions;
      this.openModal()
    })

    db.dataGrid.options.readAll((grids) => {
      this.grids = []
      this.selectedGrid = null

      for (let gridId in grids) {
        this.grids.push({ text: grids[gridId].title, value: gridId })
      }
    })
  },
  mounted () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).remove()
    }
  }
}
</script>
